import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ngxAny',
    standalone: false
})
export class AnyPipe implements PipeTransform {
  transform(value: any[]): boolean {
    return Array.isArray(value) && value.length > 0;
  }
}
